import { Injectable } from '@angular/core';
import {map, Observable} from "rxjs";
import {
  IPracticeModel, IResultItemPracticeModel,
  PracticeIndicatorModel,
  PracticeModel, ResultItemPracticeModel,IResultPracticeModel, ResultPracticeModel
} from "../../models/accounts/practice.model";
import {PracticeHttpService} from "./https/practice-http.service";


@Injectable({
  providedIn: 'root'
})
export class PracticeService {

  constructor(private practiceHttpService: PracticeHttpService) { }

  getPractices(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0): Observable<ResultPracticeModel> {
    return this.practiceHttpService
      .getPractices(wheres, limit, offset)
      .pipe(
        map((admin: IResultPracticeModel) => ResultPracticeModel.fromObject(admin))
      );
  }
  userRolePractice  (practiceId: string): Observable<any> {
    return this.practiceHttpService
      .userRolePractice(practiceId)
      .pipe(
        map((result: any) => result)
        //map((result: IResultInvitations) => ResultInvitations.fromObject(result))
      );
  }
  getPracticeIndicator(practiceId:string): Observable<PracticeIndicatorModel> {
    return this.practiceHttpService
      .getPracticeIndicator(practiceId)
      .pipe(
        map((result: PracticeIndicatorModel) => result)
        //map((admin: IResultPracticeModel) => ResultPracticeModel.fromObject(admin))
      );
  }



}
